// src/theme/components/formStyles.js
const formStyles = (theme) => ({
  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiInputBase-input": {
          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem", // Ensure readable font size on mobile
            padding: theme.spacing(1.5, 1), // Larger touch target
          },
        },
      },
    },
  },
  // You can add other form component styles here (e.g., Select, Checkbox, etc.)
});

export default formStyles;
